import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const AutoLoanList = () => {
    const [auto_loans, setAutoLoans] = useState([]);
    const [loading, setLoading] = useState(true); // Manage loading state

    useEffect(() => {
        // Fetch the auto loan data from the API
        axios.get('/api/balance_sheet/financing/auto_loans/')
            .then(response => {
                console.log(response.data); // Log the response data for debugging
                setAutoLoans(response.data); // Populate the component state
                setLoading(false); // Stop loading
            })
            .catch(error => {
                console.error('Error fetching auto loan data:', error);
                setLoading(false); // Stop loading even on error
            });
    }, []); // Empty dependency array ensures this runs only on mount

    // Loading message while fetching data
    if (loading) {
        return <div>Loading auto loans...</div>;
    }

    const handleRemove = async (id) => {
        try {
            await axios.delete(`/api/balance_sheet/financing/auto_loans/${id}/`); // Call DELETE API
            // Update state to remove the deleted auto loan
            setAutoLoans((prevAutoLoans) => prevAutoLoans.filter(auto_loan => auto_loan.id !== id));
            alert("Loan removed successfully");
        } catch (error) {
            console.error("Error removing loan:", error);
            alert("There was an error removing the loan.");
        }
    };

    // Helper function to format currency
    const formatCurrency = (amount) => {
        return `$${Math.round(amount).toLocaleString()}`;
    };

    return (
        <div style={{ marginLeft: '40px' }}>
            <div style={{ margin: '20px' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <h1 style={{ marginRight: '20px' }}>Auto Loan List</h1>
                <div>
                    <Link style={{ marginRight: '10px' }} to="/balance_sheet/financing/">  All Debt </Link>
                </div>
            </div>
                <Link to="/balance_sheet/financing/create-loan/">
                    <button type="button" className="btn btn-primary">Create New Auto Loan</button>
                </Link>
            {/* Include other details as needed */}
            </div>
            <table className="auto-loan-table">
                <thead>
                    <tr>
                        <th>Loan ID</th>
                        <th>Lender</th>
                        <th>Loan Amount</th>
                        <th>Interest Rate</th>
                        <th>Term (Years)</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {auto_loans.length > 0 ? (
                        auto_loans.map(auto_loan => (
                            <tr key={auto_loan.id}>
                                <td>
                                    <Link to={`/balance_sheet/financing/auto_loans/${auto_loan.id}`}>{auto_loan.id}</Link>
                                </td>
                                <td>{auto_loan.lender}</td>
                                <td>{formatCurrency(auto_loan.amount)}</td>
                                <td>{auto_loan.initial_interest_rate}%</td>
                                <td>{auto_loan.term_in_years}</td>
                                <td>
                                    <button type="button" className="btn btn-danger" onClick={() => handleRemove(auto_loan.id)}>Remove</button>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="6" style={{ textAlign: 'center' }}>No auto loans found.</td>
                        </tr>
                    )}
                </tbody>
            </table>
            <style jsx>{`
                .auto-loan-table {
                    margin: 20px;
                    width: 90%;
                    table-layout: auto;
                    border-collapse: collapse;
                }
                .auto-loan-table th, .auto-loan-table td {
                    border: 1px solid #ccc;
                    padding: 10px;
                    text-align: left;
                }
                .auto-loan-table th {
                    background-color: #f0f0f0;
                }
                button {
                    background-color: #ff4d4d;
                    color: white;
                    border: none;
                    padding: 5px 10px;
                    cursor: pointer;
                }
                button:hover {
                    background-color: #ff0000;
                }
            `}</style>
        </div>
    );
};

export default AutoLoanList;